import React, { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { NewApplicants } from "../../templates/NewApplicants";

const NewApplicantsPage = ({
  sideNav,
  isLoading,
  dispatchSetSideNav,
  onChange,
  onTabClick,
  readApplicants,
  unreadApplicants,
  unreadTotal,
  readTotal,
  currentReadPage,
  currentUnreadPage,
}: any) => {
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    location.pathname.includes("/recruit/new-applicants") &&
      dispatchSetSideNav(true);
  }, [dispatchSetSideNav, location.pathname]);

  const onClickApplicant = (key: any) => {
    history.push(`/recruit/new-applicants/${key}`);
  };

  return (
    <NewApplicants
      onClickApplicant={onClickApplicant}
      readApplicants={readApplicants}
      unreadApplicants={unreadApplicants}
      readTotal={readTotal}
      unreadTotal={unreadTotal}
      isLoading={isLoading}
      onChange={onChange}
      onTabClick={onTabClick}
      currentReadPage={currentReadPage}
      currentUnreadPage={currentUnreadPage}
    />
  );
};

export default NewApplicantsPage;
